import { formatMoney } from 'accounting'

import {
  Form, Line, SidebarModalListItem, SidebarNoticeBox,
} from '@domain-group/suit-theme'

import { useCreateFinanceApplicationModalPayload } from '../hooks/useCreateFinanceApplicationModal'

type SelectQuotesProps = {
  createFinanceApplicationModalPayload: useCreateFinanceApplicationModalPayload,
}

const SelectQuotes = (props: SelectQuotesProps) => {
  const { createFinanceApplicationModalPayload } = props

  const {
    callbacks: { selectQuote },
    campaignQuoteIds,
    filteredCampaignQuotes,
    hasFilteredCampaignQuotes,
    loadingQuotes,
  } = createFinanceApplicationModalPayload

  if (loadingQuotes) return null

  return (
    <>
      {/*
       // @ts-expect-error TS2741 */}
      <Form.Field label="Quotes" labelProps={{ marginBottom: hasFilteredCampaignQuotes ? 0 : 'large' }} />

      {!hasFilteredCampaignQuotes && (
        <>
          <SidebarNoticeBox boxProps={{ marginBottom: 0 }}>
            <SidebarNoticeBox.Title>No Quotes Available</SidebarNoticeBox.Title>

            <SidebarNoticeBox.Paragraph>
              Quotes have not been created in this campaign. Create a quote for it to show up for selection.
            </SidebarNoticeBox.Paragraph>
          </SidebarNoticeBox>

          <Line />
        </>
      )}

      {filteredCampaignQuotes.map((campaignQuote, index) => {
        const selected = campaignQuoteIds.includes(campaignQuote.id)
        const isLastItem = index === filteredCampaignQuotes.length - 1

        return (
          <SidebarModalListItem
            boxProps={{ borderBottom: isLastItem ? '1px solid' : '1px dashed' }}
            // @ts-expect-error TS2345
            checkboxOnClick={() => selectQuote(campaignQuote)}
            isChecked={selected}
            key={campaignQuote.id}
            // @ts-expect-error TS2339
            secondaryText={formatMoney(campaignQuote.total)}
            showCheckbox
            title={campaignQuote.title}
          />
        )
      })}
    </>
  )
}

export default SelectQuotes
